import vClickOutside from 'v-click-outside';
import {mapState, mapGetters} from 'vuex';
import {CART_ITEM_TYPE, WEBITEM_TYPE} from '../../common/constants/constants';

import eventBus from '../../common/event-bus/event-bus';

export default {
	directives: {
		clickOutside: vClickOutside.directive
	},
	computed: {
		...mapState('newItemInCartModalStore', ['addedElement']),
		...mapGetters('cartsStore', ['activeAddress']),

		showAddress() {
			return !!this.addedElement.items.filter(item => item.kombiItems ? !!item.kombiItems.filter(_item => _item.tiedToEndpoint).length : item.tiedToEndpoint).length;
		},

		displayedAddress() {
			return this.showAddress && this.activeAddress ? `${this.activeAddress.telepulesNev}, ${this.activeAddress.irsz}, ${this.activeAddress.utca}, ${this.activeAddress.hazSzam}` : '';
		},

		TYPE() {
			return CART_ITEM_TYPE;
		},

		type() {
			if (this.products.length == 1 && !this.services.length) {
				return CART_ITEM_TYPE.PRODUCT;
			} else if (this.services.length == 1 && !this.products.length) {
				return CART_ITEM_TYPE.SERVICE;
			} else {
				return CART_ITEM_TYPE.WEBITEM;
			}
		},

		services() {
			return this.addedElement.items.filter(item => item.type == WEBITEM_TYPE.SOLO_SZOLG || item.type == WEBITEM_TYPE.KOMB_SZOLG) || [];
		},

		products() {
			return this.addedElement.items.filter(item => item.type == WEBITEM_TYPE.PRODUCT) || [];
		}
	},
	methods: {
		toggle() {
			eventBus.$emit('close-newItemInCartPopup');
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/MDL08-new-item-in-cart/MDL08-new-item-in-cart.js